import { type TCoreButtonViewProps } from '@core/widgets';
import { useBehavior, useTriggerAction, useUpdateWidgetValue } from '@libs/core';
import { ActionActionTypeEnum, TWidgetProps } from '@libs/types';
import React from 'react';
import { TSelectorRegularData } from '../../../types/data';
import { TRowOption, TSelectorRegularOption } from '../../../types/options';
import { RowRegularView } from './RowRegularView';

export const RowRegularWidget = ({ widget }: TWidgetProps<TSelectorRegularData, TRowOption & TSelectorRegularOption>) => {
    const { updateWidgetValue } = useUpdateWidgetValue(widget);
    const { triggerActionsByType } = useTriggerAction(widget);
    const { isDisabled, isHidden } = useBehavior(widget);

    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    const resolvedValue = widget.data?.value ?? false;
    const resolvedTitle = widget.data?.messages?.title || widget.data?.title;
    const resolvedSubtitle = widget.data?.messages?.subtitle || widget.data?.subtitle;
    const resolvedMetaText = widget.data?.messages?.metaText || widget.data?.metaText;
    const resolvedTopText = widget.data?.messages?.topText || widget.data?.topText;
    const resolvedIconName = widget.data?.iconName;
    const resolvedFlagIcon = widget.data?.flagIcon;
    const resolvedAvatar = widget.data?.avatar;
    const resolvedIconHierarchy = widget.options?.iconHierarchy;
    const resolvedIconVariant = widget.options?.iconVariant;
    const resolvedMetaVariant = widget.options?.metaVariant;
    const resolvedMetaHierarchy = widget.options?.metaHierarchy;
    const resolvedVariant = widget.options?.variant === 'CHECK' ? ('CHECK' as const) : undefined;
    const resolvedMargin = widget.options?.margin;

    const handleAction = () => {
        updateWidgetValue(!widget.data.value);
        triggerActionsByType(ActionActionTypeEnum.onClick).then();
    };

    return (
        <RowRegularView
            version={widget.version}
            widget={widget as TCoreButtonViewProps['widget']}
            uid={widget.uid}
            title={resolvedTitle}
            subtitle={resolvedSubtitle}
            metaText={resolvedMetaText}
            topText={resolvedTopText}
            value={resolvedValue}
            iconName={resolvedIconName}
            flagIcon={resolvedFlagIcon}
            avatar={resolvedAvatar}
            subtitleIconName={widget.data?.subtitleIconName}
            iconHierarchy={resolvedIconHierarchy}
            iconVariant={resolvedIconVariant}
            metaVariant={resolvedMetaVariant}
            metaHierarchy={resolvedMetaHierarchy}
            variant={resolvedVariant}
            margin={resolvedMargin}
            isError={widget.options?.isError}
            isDisabled={isDisabled}
            isHide={isHidden}
            handleClick={handleAction}
            parentStyleNames={parentStyleNames}
        />
    );
};
